import * as React from 'react';
import {Helmet} from 'react-helmet';

import {headTitle} from 'shells/document/head-title';

import {PageWrapper} from '../layout/page-wrapper';

import styles from './ai-page-wrapper.module.css';

type Props = {
    tabTitle: string;
    header?: React.ReactNode;
    children: React.ReactNode;
};

export function AiPageWrapper(props: Props) {
    // Scroll to the header when the page changes
    React.useEffect(() => {
        const header = document.getElementById('ai-wrapper-header');
        if (header) {
            header.scrollIntoView({
                behavior: 'instant',
            });
        }
    }, [props.tabTitle]);

    return (
        <PageWrapper minWidth={800}>
            <Helmet>
                <title>{headTitle(props.tabTitle)}</title>
            </Helmet>
            <div className='overflow-x-hidden border-top-left-8'>
                <div id='ai-wrapper-header'>{props.header}</div>
                <div className='flex background-white justify-center'>
                    <div className={styles['content-container']}>{props.children}</div>
                </div>
            </div>
        </PageWrapper>
    );
}
